module.exports = __webpack_public_path__ + "static/img/sj_cjbg_1.5c49a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_cjbg_1.png
// module id = z6Qg
// module chunks = 1